function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4a1 1 0 100 2 1 1 0 000-2zM9 5a3 3 0 116 0 3 3 0 01-6 0zM5 18a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0zM19 18a1 1 0 100 2 1 1 0 000-2zm-3 1a3 3 0 116 0 3 3 0 01-6 0zM12 12a2 2 0 100 4 2 2 0 000-4zm-4 2a4 4 0 118 0 4 4 0 01-8 0z",
  fill: "#8C8C8C"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 6a1 1 0 011 1v4a1 1 0 01-2 0V7a1 1 0 011-1zM10.314 15.219a1 1 0 01-.233 1.395l-2.8 2a1 1 0 01-1.162-1.628l2.8-2a1 1 0 011.395.233zM13.687 15.219a1 1 0 011.394-.233l2.8 2a1 1 0 01-1.162 1.628l-2.8-2a1 1 0 01-.232-1.395z",
  fill: "#8C8C8C"
});

function SvgIconHomeSocial(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgIconHomeSocial;